import jwt from 'jsonwebtoken'
import { get } from 'lodash'

export const getJwtToken = state => get(state, 'auth.token')
export const getPublicCert = state => get(state, 'auth.publicCert')
// Decode only: jsonwebtoken's verify needs Node's crypto.KeyObject, which webpack's browser crypto shim lacks. The API verifies every request.
export const getTokenPayload = state => {
  const payload = jwt.decode(getJwtToken(state))
  if (!payload || (payload.exp && payload.exp * 1000 <= Date.now())) {
    return null
  }
  return payload
}
export const getIsAuthenticated = state => !!getTokenPayload(state)
export const getUserId = state => {
  const payload = getTokenPayload(state) || {}
  return payload.userid || payload.accountId
}
export const getUserName = state => {
  const payload = getTokenPayload(state) || {}
  return {
    firstName: payload.firstName,
    lastName: payload.lastName,
  }
}

export const getUserEmail = state => {
  const payload = getTokenPayload(state) || {}
  return payload.email
}

export const getBraintreeId = state => {
  const payload = getTokenPayload(state) || {}
  return payload.braintreeId
}
// biome-ignore lint/complexity/useOptionalChain: TODO
export const getIsGuestSignup = state => !!(getTokenPayload(state) || {}).isGuest
export const getUser = state => get(state, 'auth.user')
